export enum BadgeSubscriptionStatus {
	max = 'max',
	pro = 'pro',
	basic = 'basic'
}

export enum BadgeExperienceLevel {
	platinium = 'platinium',
	gold = 'gold',
	silver = 'silver',
	bronze = 'bronze',
	basic = 'basic'
}

export interface IBadgeDetails {
	isMentor: boolean;
	subscriptionStatus: BadgeSubscriptionStatus;
	experienceLevel: BadgeExperienceLevel;
}

export const defineUserProfileBadge = (badgesString: string): IBadgeDetails => {
	if (!badgesString || !badgesString?.trim()) {
		return null;
	} else {
		const badges = badgesString.split('|');
		const isMentor = badges.includes('mod');
		let subscriptionStatus: BadgeSubscriptionStatus = BadgeSubscriptionStatus.basic;
		let experienceLevel: BadgeExperienceLevel = BadgeExperienceLevel.basic;

		if (badges.includes('max')) {
			subscriptionStatus = BadgeSubscriptionStatus.max;
		} else if (badges.includes('pro')) {
			subscriptionStatus = BadgeSubscriptionStatus.pro;
		}

		if (badges.includes('platinium')) {
			experienceLevel = BadgeExperienceLevel.platinium;
		} else if (badges.includes('gold')) {
			experienceLevel = BadgeExperienceLevel.gold;
		} else if (badges.includes('silver')) {
			experienceLevel = BadgeExperienceLevel.silver;
		} else if (badges.includes('bronze')) {
			experienceLevel = BadgeExperienceLevel.bronze;
		}

		return {
			isMentor,
			subscriptionStatus,
			experienceLevel
		};
	}
};